var _defs, _path, _path2, _path3, _rect, _rect2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 661.63 603.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #ff5e46;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #28082a;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M661.63,484.07h-34v-109.21c0-40.85-33.42-74.27-74.27-74.27-18.66,0-35.76,6.99-48.85,18.46h-.02s-.19.19-.19.19c-2.3,2.03-4.47,4.2-6.5,6.5l-99.88,99.76h0c-.56.53-1.1,1.07-1.65,1.6v-129.05c0-40.85-33.42-74.27-74.27-74.27-18.66,0-35.76,6.99-48.84,18.46h-.02s-.19.19-.19.19c-2.3,2.03-4.47,4.2-6.5,6.5l-99.88,99.76h0c-1,.92-1.96,1.87-2.9,2.84v-161.81H0v119.1h33.99v295.15h593.64v-.14h34v-119.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.62,603.95v-189.65c0-28-22.91-50.91-50.91-50.91h0c-28,0-50.91,22.91-50.91,50.91v189.65h101.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.98,603.95v-112.83c0-28-22.91-50.91-50.91-50.91h0c-28,0-50.91,22.91-50.91,50.91v112.83h101.82Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 185.53,
    y: 517.75,
    width: 61.41,
    height: 86.21,
    rx: 30.7,
    ry: 30.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 415.17,
    y: 517.75,
    width: 61.41,
    height: 86.21,
    rx: 30.7,
    ry: 30.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M443.06,62.89h-36.81V16.49c10.74-5.88,21.98-10.1,33.74-12.65,11.76-2.55,24.54-3.83,38.34-3.83,30.16,0,52.27,6.84,66.34,20.51,14.06,13.68,21.09,32.66,21.09,56.94,0,11.25-1.98,21.73-5.94,31.44-3.97,9.72-9.72,18.41-17.26,26.07-7.54,7.67-16.68,14.13-27.42,19.36-10.74,5.24-23.01,8.76-36.81,10.54v38.34h-24.54v-54.45c11.5-2.31,21.53-5.27,30.1-8.87,8.56-3.6,15.72-8.23,21.47-13.89,5.75-5.66,10.1-12.54,13.04-20.64,2.94-8.1,4.41-17.81,4.41-29.12,0-6.94-.9-13.82-2.68-20.63-1.79-6.81-4.6-12.92-8.44-18.32-3.83-5.4-8.76-9.77-14.76-13.11-6.01-3.34-13.23-5.02-21.67-5.02-8.95,0-15.91.72-20.9,2.15-4.98,1.43-8.76,3.19-11.31,5.27v36.3ZM435.77,250.78c0-7.92,2.68-14.19,8.05-18.79,5.37-4.6,12.52-6.9,21.47-6.9s16.23,2.3,21.86,6.9c5.62,4.6,8.44,10.87,8.44,18.79s-2.82,13.8-8.44,18.41c-5.63,4.6-12.91,6.9-21.86,6.9s-16.1-2.3-21.47-6.9c-5.37-4.6-8.05-10.74-8.05-18.41Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotQuestion);
export default __webpack_public_path__ + "static/media/mascot-question.2039c3b40208d5d6b04515a361d9cc80.svg";
export { ForwardRef as ReactComponent };